import { Market } from "src/state/master-data/state-models/market";

export interface Simulation {
    id:number;
    simProdNumber:string;        
    partPeriod:string;    
    xCorrelationId:string;     
    structMarketCOReleaseTime:string;
    userId:string;    
    status:number;      
    baseCost:number;        
    createdOn:string; 
    updatedOn:string;    
    sportMessage:string;
    productIndividualId:number;
    market:Market;
    productClass:string;
    currencyCode:string;
    currencyRate:number;
    convertedBaseCost:number;
}

export const STATUS_OPTIONS = [
  {value:'0', label:'IN_PROGRESS'},
  {value:'1', label:'SUCCESS'},
  {value:'2', label:'FAILED'}
];

export const MARKET_OPTIONS = [
  {value:'SLA', label:'SLA'},
  {value:'SEU', label:'SEU'}
];
